var $e25098e26647cc04$exports = {};
$e25098e26647cc04$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`,
    "colorSwatchPicker": `Color swatches`
};


export {$e25098e26647cc04$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
